<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" :visibleFieldForm="false" />

    <!-- 목표 및 실적 -->
    <write-grid-container title="목표 및 실적" v-model="form.subInfo" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <div class="print-input">{{ form.subInfo[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <vs-select v-if="dataType === 'selector'" class="w-full" autocomplete v-model="form.subInfo[value]" >
            <vs-select-item v-for="item in ['목표', '실적']" :text="item" :value="item"/>
          </vs-select>
          <ml-input v-else class="w-full" v-model="form.subInfo[value]" visible-counter type="number"
                    :defaultValue="header.year + 1" :min-value="1900" :max-value="2100" />
        </div>
      </template>
    </write-grid-container>
    <div>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>목표</div>
          <p v-if="isPrint" class="print-input">{{ form.subInfo.목표 }}</p>
          <div v-else class="grid" style="grid-template-columns: 1fr 130px">
            <ml-textarea class="flex-1 w-full m-0" rows="10" v-model="form.subInfo.목표" :max="2000" :readonly="board.readonly"/>
            <div class="ml-2" style="text-align: right">
              <vs-button color="secondary" type="border" style="max-width: 140px;" @click="showListPopup = true">전사 목표</vs-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="이미지첨부"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>

    <PopupLoadPrevBoard title="전사목표" :setBoardId="904" v-model="showListPopup" @selectRowData="loadGoalData" />

  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  computed: {
  },
  data() {
    return {
      showListPopup : false,
      form: {
        stdInfo: {},
        subInfo: {},
        photoList: [],
        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["year", "selector"],
        labels: ["대상년도", "목표/실적"],
        values: ["대상년도", "목표실적"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }

  },
  methods: {
    loadGoalData(data) {
      if (data && data.post_content) {
        const content = JSON.parse(data.post_content)
        const body = content.body

        this.form.subInfo.목표 = body.subInfo.목표
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
